import React, { useEffect } from "react";
import * as Yup from "yup";
import { Box } from "@material-ui/core";
import { FTLTextField, FTLButton, FTLJsonLogger, FTLPasswordField, } from "ftl-dashboards-ui-kit";
import { useFormik } from "formik";
import { snackbarService, handleError, useValidationErrorSnackbar, requiredMessage, FTLObjectUtils, } from "ftl-dashboards-core";
export const initStatePassForm = {
    password: "",
    newPassword: "",
    confirmPassword: "",
};
export const passSchema = () => {
    return Yup.object().shape({
        password: Yup.string().required(requiredMessage),
        newPassword: Yup.string().required(requiredMessage),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("newPassword")], "Пароли должны совпадать")
            .required(requiredMessage),
    });
};
export const SecurityTab = ({ changePass, setChangePass, changeProfilePassword, setTabIndex, }) => {
    const formikPass = useFormik({
        initialValues: initStatePassForm,
        validationSchema: passSchema,
        onSubmit: (values) => {
            changeProfilePassword(values)
                .then((response) => {
                formikPass.setValues(Object.assign({}, formikPass.values), false);
                snackbarService.showSnackbar({
                    variant: "success",
                    message: "пароль изменен успешно!",
                });
                return response;
            })
                .catch((error) => {
                handleError({
                    error,
                    defaultError: "Произошла ошибка при изменении пароля!",
                });
            })
                .finally(() => {
                formikPass.setSubmitting(false);
            });
        },
    });
    useValidationErrorSnackbar({
        condition: formikPass.isSubmitting && !formikPass.isValid,
        message: FTLObjectUtils.getFirstPrimitiveValue(formikPass.errors, "string"),
    });
    useEffect(() => {
        if (!formikPass.isSubmitting && formikPass.errors.confirmPassword)
            setTabIndex(2);
    }, [formikPass.errors.confirmPassword, formikPass.isSubmitting]);
    return (React.createElement(Box, null,
        React.createElement(Box, { maxWidth: 360 }, changePass ? (React.createElement(Box, { mt: 6 },
            React.createElement(FTLJsonLogger, { label: "\u0421\u0442\u0435\u0439\u0442 \u0444\u043E\u0440\u043C\u044B", value: formikPass.values }),
            React.createElement(FTLJsonLogger, { label: "\u041E\u0448\u0438\u0431\u043A\u0438 \u0444\u043E\u0440\u043C\u044B", value: formikPass.errors }),
            React.createElement("form", { id: "new-pass", onSubmit: (e) => {
                    e.preventDefault();
                    formikPass.handleSubmit();
                } },
                React.createElement(Box, null,
                    React.createElement(FTLPasswordField, { fullWidth: true, label: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", name: "password", required: true, value: formikPass.values.password, error: formikPass.errors.password ? true : false, onChange: formikPass.handleChange, onBlur: formikPass.handleBlur })),
                React.createElement(Box, { mt: 6 },
                    React.createElement(FTLPasswordField, { fullWidth: true, label: "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", name: "newPassword", required: true, value: formikPass.values.newPassword, error: formikPass.errors.newPassword ? true : false, onChange: formikPass.handleChange, onBlur: formikPass.handleBlur })),
                React.createElement(Box, { mt: 6 },
                    React.createElement(FTLPasswordField, { fullWidth: true, label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F", name: "confirmPassword", required: true, value: formikPass.values.confirmPassword, error: formikPass.errors.confirmPassword ? true : false, onChange: formikPass.handleChange, onBlur: formikPass.handleBlur }))),
            React.createElement(Box, { display: "flex", mt: 6 },
                React.createElement(Box, null,
                    React.createElement(FTLButton, { async: formikPass.isSubmitting, type: "submit", color: "primary", form: "new-pass" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")),
                React.createElement(Box, { ml: 2, mr: 2 },
                    React.createElement(FTLButton, { variant: "text", onClick: () => setChangePass(false) }, "\u041E\u0442\u043C\u0435\u043D\u0430"))))) : (React.createElement(Box, { mt: 6 },
            React.createElement(FTLTextField, { label: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", type: "password", disabled: true, value: "password" }),
            React.createElement(Box, { mt: 6 },
                React.createElement(FTLButton, { color: "secondary", onClick: () => setChangePass(true) }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C")))))));
};
export default SecurityTab;
//# sourceMappingURL=SecurityTab.js.map